// extracted by mini-css-extract-plugin
export default {"trainingsEmpty":"TrainingsList-module__trainingsEmpty"};